"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _StyleObject = _interopRequireDefault(require("./StyleObject.js"));
//@ts-check

/**
 * @param {object} props
 * @param {number} order
 * @param {StyleObject} oStyle
 * @returns {props}
 */
var applyClassName = function applyClassName(props, order, oStyle) {
  var styleId = oStyle.styleId;
  var arr = [styleId];
  for (var j = 1; j <= order; j++) {
    arr.push(styleId + "" + j);
  }
  props.className = (props.className ? props.className + " " : "") + arr.join(" ");
  return props;
};

/**
 * @param {object} props
 * @param {StyleObject} oStyle
 * @returns {props}
 */
var applyInlineStyle = function applyInlineStyle(props, oStyle) {
  if ((0, _reshowConstant.IS_ARRAY)(oStyle.selector)) {
    return props;
  }
  if (!props.style) {
    props.style = {};
  }
  oStyle.styleRules.forEach(
  /**
   * @param {object} one
   */
  function (one) {
    return (0, _reshowConstant.KEYS)(one).forEach(function (key) {
      return props.style[key] = one[key];
    });
  });
  return props;
};

/**
 * @param {object} props
 * @param {number} order
 */
var applyStyle = function applyStyle(props, order) {
  return (
    /**
     * @param {object} oStyle
     * @returns {props}
     */
    function (oStyle) {
      if (!oStyle) {
        return props;
      }
      if (!oStyle.isCompiled) {
        console.warn("Not a style object", oStyle);
        return props;
      }
      return oStyle.isCompiled() && order < 10 ? applyClassName(props, order, oStyle) : applyInlineStyle(props, oStyle);
    }
  );
};

/**
 * @param {object} props
 * @param {StyleObject|StyleObject[]} styles
 * @param {number} [order]
 * @returns {props[]}
 */
var applyStyles = function applyStyles(props, styles, order) {
  if (isNaN( /**@type any*/order)) {
    order = 0;
  }
  if (!(0, _reshowConstant.IS_ARRAY)(styles)) {
    styles = [styles];
  }
  var doApply = applyStyle(props, /**@type any*/order);
  return styles.map(
  /**
   * @param {StyleObject} one
   * @returns {props}
   */
  function (one) {
    return doApply(one);
  });
};
var _default = exports["default"] = applyStyles;
module.exports = exports.default;